import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("caption", {
        "data-slot": "table-caption",
        class: _normalizeClass($setup.cn('text-muted-foreground mt-4 text-sm', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
